(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const body = document.querySelector('[data-article-body]');
    if (body) {
      body.querySelectorAll('table').forEach((t) => {
        if (t.parentElement.classList.contains('maison-article__tablewrap')) return;
        const w = document.createElement('div'); w.className = 'maison-article__tablewrap'; w.setAttribute('tabindex', '0'); w.setAttribute('role', 'region'); w.setAttribute('aria-label', 'Tableau, défilement horizontal possible');
        const o = document.createElement('div'); o.className = 'maison-article__tableouter'; t.parentNode.insertBefore(o, t); o.appendChild(w); w.appendChild(t);
        const hint = document.createElement('div'); hint.className = 'maison-article__tablehint'; hint.textContent = 'Faites défiler pour voir toutes les colonnes'; w.appendChild(hint);
        const check = () => { const sc = t.scrollWidth > w.clientWidth + 4, end = w.scrollLeft + w.clientWidth >= t.scrollWidth - 4; w.classList.toggle('is-scrollable', sc); w.classList.toggle('at-end', end); o.classList.toggle('is-scrollable', sc); o.classList.toggle('at-end', end); };
        w.addEventListener('scroll', check); window.addEventListener('resize', check); check();
      });
      /* FAQ : chaque couple h3 + p devient une carte */
      const faqTitle = Array.from(body.querySelectorAll('h2')).find((h) => /questions fr/i.test(h.textContent));
      if (faqTitle) {
        let el = faqTitle.nextElementSibling;
        while (el) {
          const next = el.nextElementSibling;
          if (el.tagName === 'H3' && next && next.tagName === 'P') { const card = document.createElement('div'); card.className = 'maison-article__faq'; el.parentNode.insertBefore(card, el); card.appendChild(el); card.appendChild(next); el = card.nextElementSibling; continue; }
          if (el.tagName === 'SCRIPT') break;
          el = next;
        }
      }
    }
    /* Comptage des clics sur les liens trackés (collecteur sogood-cta) : campagne + zone lus dans les UTM du lien */
    const racine = document.querySelector('.maison-article[data-cta-collector]');
    const collecteur = racine ? (racine.getAttribute('data-cta-collector') || '') : ''; /* Liquid n'est pas rendu dans {% javascript %} : l'URL passe par un attribut */
    document.addEventListener('click', (ev) => {
      const a = ev.target && ev.target.closest ? ev.target.closest('a[data-cta]') : null;
      if (!a || !collecteur) return;
      let c = '', z = '', m = '';
      try { const u = new URL(a.href, location.href); c = u.searchParams.get('utm_campaign') || ''; z = u.searchParams.get('utm_content') || a.getAttribute('data-cta') || ''; m = u.searchParams.get('utm_medium') || ''; } catch (e) { return; }
      if (!c || !z) return;
      const body = JSON.stringify({ c: c, z: z, m: m, p: location.pathname });
      try {
        if (!(navigator.sendBeacon && navigator.sendBeacon(collecteur, new Blob([body], { type: 'text/plain' })))) {
          fetch(collecteur, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: body });
        }
      } catch (e) { /* jamais bloquant */ }
    }, true);
    const bar = document.querySelector('[data-progress]');
    if (bar) {
      const art = document.querySelector('.maison-article');
      const update = () => { const r = art.getBoundingClientRect(); const total = art.offsetHeight - window.innerHeight; const p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1; bar.style.transform = 'scaleX(' + p + ')'; };
      window.addEventListener('scroll', update, { passive: true }); update();
    }
    const toc = document.querySelector('[data-toc]');
    const list = document.querySelector('[data-toc-list]');
    if (!body || !toc || !list) return;

    const headings = Array.from(body.querySelectorAll('h2'));
    if (headings.length < 2) return;

    const used = new Set();
    headings.forEach((h, i) => {
      if (!h.id) {
        let base = (h.textContent || 'section')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '')
          .slice(0, 60) || 'section-' + (i + 1);
        let id = base;
        let n = 2;
        while (used.has(id) || document.getElementById(id)) { id = base + '-' + n++; }
        h.id = id;
      }
      used.add(h.id);
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;

    if (!('IntersectionObserver' in window)) return;
    const links = new Map(headings.map((h) => [h.id, list.querySelector('a[href="#' + h.id + '"]')]));
    let current = null;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        if (current) current.removeAttribute('aria-current');
        current = links.get(entry.target.id);
        if (current) current.setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    headings.forEach((h) => observer.observe(h));
  })();

  } catch(e) { console.error(e); }
})();
})();
